// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"5b618963","703":"6f54c512"}[chunkId] + ".chunk.js";
};